import { useTemplate } from "@/lib/helpers/template"
import classNames from "classnames"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./accordion.module.css"

export default function Accordion({ block, settings }) {
  const template = useTemplate()
  const { attrs, innerBlocks } = block
  const { classList, bgColor, blockGap, heading, text } = attrs

  if (innerBlocks.length === 0) {
    return null
  }

  const defaultGap = template === "article" ? "content" : "normal"
  const gap =
    template === "article" && blockGap === "normal"
      ? "content"
      : settings?.blockGap ?? blockGap ?? defaultGap

  return (
    <Block
      block={block}
      width="bleed"
      gap={gap}
      className={classNames(styles.wrapper, "bg-color-" + bgColor, {
        "is-faq": settings?.isFaq,
        "is-article": template === "article",
        "toggle-has-accent-color":
          classList && classList.includes("toggle-has-accent-color")
      })}>
      <div className="inner-wrapper">
        {template !== "article" && (
          <BlockHeader
            align="inner-column"
            heading={heading}
            text={text}
            className="col-span-4"
          />
        )}
        <Blocks blocks={innerBlocks} />
      </div>
    </Block>
  )
}
